// Consolidated: Redirects to CourseDetailPage which contains the ScormPlayer overlay
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const CoursePlayerPage = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to course detail page — ScormPlayer is now an overlay launched from there
    navigate(`/course/${courseId}`, { replace: true });
  }, [courseId, navigate]);

  return null;
};

export default CoursePlayerPage;
